import { useEffect, useState } from 'react';
import { t } from 'i18next';

import { useLocationsQuery } from '../../../components/api/queries/useLocationsQuery';
import { useQueryParams } from '../../../utils/useQueryParams';

import StickyHeader from '../../../components/StickyHeader';
import { ReportFootprintBreadcrumb } from '../../../components/report/ReportFootprintBreadcrumb';
import FootprintReportBox from '../../../presentation/components/event-detail/FootprintReportBox';

import { Button } from '@peacecover/component';
import { Xmark } from '@peacecover/icon';
import { BaseFootprint } from '../../../domain/models/locations/BaseFootprint';
import type { ILocationItemResponseBody } from '../../../types/response/ILocationItemResponseBody';

export default function ReportFootprintsPage() {
  const { queryParams, updateQueryParams, removeQueryParams } = useQueryParams();
  const kakaoUID = queryParams.get('kakaoUID') || '';
  const locationId = queryParams.get('locationId');
  const artistId = queryParams.get('artistId') || '';

  const [location, setLocation] = useState<ILocationItemResponseBody>();

  const { data: locationData } = useLocationsQuery({ kakaoUID: kakaoUID, artistId: artistId });

  useEffect(() => {
    if (locationData) {
      setLocation(locationData.locations[0]);
    }
  }, [locationData]);

  const navigateAddFootprint = () => {
    updateQueryParams({ locationId }, '/report-location/footprints-category');
  };

  return (
    <>
      <StickyHeader
        title={t('ReportFootprintsPage.pageTitle', { defaultValue: '제보하기' }) as string}
        alwaysShowTitle={true}
        showBackButton={false}
        showTitle={true}
        leftContent={
          <Xmark
            size={24}
            className="text-text-main-lv2"
            onClick={() =>
              removeQueryParams(['kakaoUID', 'locationName'], '/report-location/search-location')
            }
          />
        }
      />
      <div className="flex flex-col pt-[calc(54px+env(safe-area-inset-top))] pb-[calc(128px+env(safe-area-inset-bottom))]">
        <div className="flex flex-col gap-[18px] px-[24px] py-[10px]">
          <div className="mx-[-24px]">
            <ReportFootprintBreadcrumb />
          </div>
          <h1 className="text-[26px] font-bold leading-[31px] text-left whitespace-pre-wrap">
            {t('ReportFootprintsPage.title', {
              defaultValue: '이미 등록된건 아닌지\n한 번 더 확인해주세요.'
            })}
          </h1>
        </div>
        <div className="flex flex-col gap-[14px] px-[24px] mt-[14px]">
          {location?.footprints?.map((footprint) => (
            <div key={footprint.footprintId}>
              <FootprintReportBox
                footprint={BaseFootprint.fromResponse(footprint)}
                lotAddress={location?.lotAddress}
              />
            </div>
          ))}
        </div>
        <Button
          size="large"
          btnColor="secondary"
          onClick={navigateAddFootprint}
          className="mx-[24px] mt-[25px] text-[17px] font-semibold"
        >
          {t('ReportFootprintsPage.createFootprint', {
            defaultValue: '없어요, 새로 등록할래요.'
          })}
        </Button>
      </div>
    </>
  );
}
